import React, { useState } from 'react';

const gematriaValues = {
  א: 1, ל: 30, ב: 2, מ: 40, ג: 3, נ: 50, ד: 4, ס: 60, ה: 5, ע: 70,
  ו: 6, פ: 80, ז: 7, צ: 90, ח: 8, ק: 100, ט: 9, ר: 200, י: 10,
  ש: 300, כ: 20, ת: 400, ך: 20, ץ: 90, ף: 80, ן: 50, ם: 40
};

const GematriaCalculator = () => {
  const [inputText, setInputText] = useState('');
  const [results, setResults] = useState([]);

  const calculateGematria = () => {
    // Split the input text into words
    const words = inputText.split(/\s+/);

    // Calculate gematria values for each word
    const gematriaResults = words.map(word => {
      const gematriaValue = [...word].reduce((acc, char) => {
        return acc + (gematriaValues[char] || 0);
      }, 0);
      return `${gematriaValue} : ${word}`;
    });

    // Update the state with the results
    setResults(gematriaResults.join('\n'));
  };

  const handleDownload = () => {
    const element = document.createElement('a');
    const file = new Blob([results], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = 'gematria.Torah.txt';
    document.body.appendChild(element);
    element.click();
  };

  return (
    <div>
      <p></p>Simple Gematria Calculator<p></p>
      <textarea
        rows="10"
        cols="50"
        placeholder="Enter Hebrew text here..."
        value={inputText}
        onChange={e => setInputText(e.target.value)}
      ></textarea>
      <br />
      <button onClick={calculateGematria}>Calculate Gematria</button>
      <button onClick={handleDownload}>Download Gematria File</button>
      <div>
        
        <pre>{results}</pre>
      </div>
    </div>
  );
};

export default GematriaCalculator;
